import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LOOKUP from "constants/lookup";
import GenericTable from "screens/components/advanced/GenericTable";

class ProductCategoryBulkUpdatePriceHistoryList extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.setState({ isOpen: this.props.isOpen });
  }
  getCategoryTitle(categoryId) {
    const category = this.props.history.filter(
      (item) => item.productCategoryId == categoryId
    );
    return (
      <Link to={`/employee/edit/${category[0].productCategoryId}`}>
        {category[0].productCategoryTitle}
      </Link>
    );
  }
  getCategoryGroup() {
    const his = [
      ...new Set(this.props.history && this.props.history.map((item) => item.productCategoryId)),
    ];
    return his.map((catItem) => (
      <li className="list-group-item list-group-item-success">
        <h4>{this.getCategoryTitle(catItem)}</h4>
        <GenericTable
          className="table_center tableHeaderwhiteColorFont"
          stripedRows={true}
          columns={LOOKUP.productCategory.tableColumnsBulkUpdatePriceHistory}
          rows={this.getCategoryData(catItem)}
        />
      </li>
    ));
  }
  getCategoryData(categoryId) {
    const his = this.props.history;
    return his
      .filter((item) => item.productCategoryId == categoryId)
      .map((item) => {
        return {
          userTitle: (
            <Link to={`/employee/edit/${item.userId}`}>{item.userTitle}</Link>
          ),
          bulkPriceValueType: (item.bulkPriceValueType != null ? item.bulkPriceValueType : "-"),
          priceValue:
            item.priceValue != null
              ? item.priceValue
              : "-",
          updateCount: item.updateCount != null ? item.updateCount : "-",
          priceByCategoryMode: (item.priceByCategoryMode != null ? item.priceByCategoryMode : "-"),
          creationDate:
            item.creationDate != null
              ? moment(item.creationDate).format("YYYY-MM-DD")
              : "-",
        };
      });
  }
  render() {
    return (
      <div>
        <Dialog
          title={"Bulk Update Price By Category History"}
          titleStyle={{ textAlign: "center", paddingBottom: `0px` }}
          // modal={true}
          open={this.props.isOpen}
          sx={{
            '& .MuiDialog-paper':
            {
              position: "absolute",
              left: "50%",
              width: "900px",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }
          }}
        >
          <DialogTitle className="p-2">Bulk Update Price By Category History</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => this.props.onCancel()}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent >
            <div
              className="row pb-2 pl-2"
            // style={{
            //   overflowY: `scroll`,
            //   overflowX: `hidden`,
            //   maxHeight: `500px`,
            // }}
            >
              <ul className="list-group">{this.getCategoryGroup()}</ul>
            </div></DialogContent>

          <hr />

        </Dialog>
      </div>
    );
  }
}
function mapStatetoProps(state) {
  return {
    branchId: state.common.branchId,
    history: state.entity.productCategoryBulkUpdatePriceHistoryList,
    history_lenght: state.entity.productCategoryBulkUpdatePriceHistoryListLength
  };
}
function mapDispatchToProps(dispatch) {
  return {

  };
}

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ProductCategoryBulkUpdatePriceHistoryList);
